module.exports = function() {
  return new Worker(__webpack_public_path__ + "a53f5c97aaddc629e9d1.worker.js");
};